/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesList.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { fineOwingAction, editFineNumberAction, deleteFineAction } from 'redux/actions'

const FinesList = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const dispatch = useDispatch()
  const fines = useSelector((state) => state.app.fines)

  useEffect(() => {
    try {
      if (fines.length === 0) {
        history.push(`/${i18n.language}${t('routes.fine_info')}`)
      }
      fines.map((fine) => {
        if (fine && fine.fineOwing === '' && fine.paymentAmount === '') {
          dispatch(deleteFineAction(fine.fineNumber))
        }
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [fines])

  const getFineOwingSum = (type) => {
    try {
      return fines
        .filter((obj, index, self) => index === self.findIndex((o) => o.fineNumber === obj.fineNumber))
        .reduce(function (a, b) {
          return a + parseFloat(b[type])
        }, 0)
    } catch (e) {
      console.log(e)
    }
  }

  const getPaymentAmountSum = (type) => {
    try {
      return fines.reduce(function (a, b) {
        return a + parseFloat(b[type])
      }, 0)
    } catch (e) {
      console.log(e)
    }
  }

  const getBalanceRemainingSum = () => {
    try {
      return getFineOwingSum('fineOwing') - getPaymentAmountSum('paymentAmount')
    } catch (e) {
      console.log(e)
    }
  }

  const getAmountString = (num, main) => {
    try {
      if (main) {
        return i18n.language === 'en' ? (
          <td>
            <strong>$ {`${num}`}</strong>
          </td>
        ) : (
          <td>
            <strong>{`${num.toString().replace('.', ',')}`} $</strong>
          </td>
        )
      }
      return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
    } catch (e) {
      console.log(e)
    }
  }

  // const removeZerosAfterDecimal = (num) => {
  //   try {
  //     return (num.substring(num.length - 3) === '.00' || num.substring(num.length - 3) === ',00') ? num.substring(0, num.length - 3) : num
  //   }
  //   catch (err) {
  //     console.log(err)
  //   }
  // }

  return (
    <div className="row">
      <div className="col-xs-12 col-md-8">
        <div className={styles['overflow_mobile']}>
          <table className={['table table-bordered', styles['fines_table']].join(' ')}>
            <thead>
              <tr>
                <th>{t('fines_list.fine_number')}</th>
                <th>{t('fines_list.fine_owing')}</th>
                <th>{t('fines_list.payment_amount')}</th>
                <th>{t('fines_list.balance')}</th>
                <th>{i18n.language === 'en' && t('fines_list.action')}</th>
              </tr>
            </thead>
            <tbody>
              {fines.map((fine, i) => {
                return (
                  <FinesRow
                    key={i}
                    fine={fine}
                    t={t}
                    i18n={i18n}
                    setIsError={setIsError}
                    getAmountString={getAmountString}
                    remaingBalance={fine.fineOwing - fine.paymentAmount}
                  />
                )
              })}
              <tr>
                <td>
                  <strong>{t('fines_list.total')}</strong>
                </td>
                <td data-label={t('fines_list.fine_owing')}>{getAmountString(getFineOwingSum('fineOwing').toFixed(2), true)}</td>
                <td data-label={t('fines_list.payment_amount')}>
                  {getAmountString(getPaymentAmountSum('paymentAmount').toFixed(2), true)}
                </td>
                <td data-label={t('fines_list.balance')}>{getAmountString(getBalanceRemainingSum().toFixed(2), true)}</td>
                <td className={styles['display_none']}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

const FinesRow = ({ fine, i18n, t, setIsError, getAmountString, remaingBalance }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const fines = useSelector((state) => state.app.fines)

  const getFineData = (fineNumber) => {
    let fineData = fines.filter((fine) => fine.fineNumber === fineNumber)
    if (fineData.length > 0) {
      return fineData[0]
    }
    return false
  }

  const editFineOnClick = (fine) => {
    try {
      dispatch(editFineNumberAction(fine.fineNumber))
      let fineData = getFineData(fine.fineNumber)
      if (fineData) {
        dispatch(fineOwingAction(fineData['fineOwing']))
      }
      history.push(`/${i18n.language}${t('routes.fine_owing_info')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const removeFineOnClick = (fineNumber) => {
    try {
      dispatch(deleteFineAction(fineNumber))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const popUpBox = (fineNumber) => {
    let confirmText = window.confirm(`${t('fines_list.are_you_sure')}`)
    if (confirmText === true) {
      // console.log('hit true')
      removeFineOnClick(fineNumber)
    }
    // else {
    //   console.log("do nothing")
    // }
  }

  return (
    <tr>
      <td data-label={t('fines_list.fine_number')}>{fine.fineNumber}</td>
      <td data-label={t('fines_list.fine_owing')}>{getAmountString(parseFloat(fine.fineOwing).toFixed(2))}</td>
      <td data-label={t('fines_list.payment_amount')}>{getAmountString(parseFloat(fine.paymentAmount).toFixed(2))}</td>
      <td data-label={t('fines_list.balance')}>{getAmountString(parseFloat(remaingBalance).toFixed(2))}</td>
      <td>
        <div style={{ display: 'flex' }}>
          {fine.paymentAmountFull !== 'final' && (
            <button
              className={['btn-xs btn-default', styles['edit_button']].join(' ')}
              onClick={() => editFineOnClick(fine)}
              value={t('fines_list.edit')}
              name={t('fines_list.edit')}
            >
              {t('fines_list.edit')}
            </button>
          )}
          <a
            href={`/${i18n.language}${t('routes.review_confirmation')}`}
            className={styles['remove_button']}
            onClick={() => popUpBox(fine.fineNumber)}
            value={t('fines_list.remove')}
            name={t('fines_list.remove')}
          >
            {t('fines_list.remove')}
            <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      </td>
    </tr>
  )
}

export default withTranslation('common')(FinesList)
